import store from '@/store';
import { getWithTimezone } from '@/utilities/DateHelpers';
import { isSsr } from '@/utilities/Utilities';

export default function useDate() {
  // hook to get the current date based on timezone and testDate data
  const getDate = () => {
    const currentDate = new Date();
    if (isSsr()) return currentDate;

    const isDemo = (store.getters['utility/path'] ?? window.location.href).includes('/campaign/view/demo');
    const currentTestDate = store.getters['global/gameTestDate'];

    if (isDemo && currentTestDate) {
      return currentTestDate;
    }

    return getWithTimezone(currentDate);
  };

  return {
    getDate
  };
}
